﻿import { Model } from 'pinia-orm'
import { Num, Str } from 'pinia-orm/decorators'

export default class RefereeTitle extends Model {
	static entity = 'referee-titles'

	@Num( 0, { notNullable: true } ) declare id: number
	@Str( '', { notNullable: true } ) declare title: string
	@Str( null ) declare shortcut: string
	@Num( 0 ) declare weight: number

	get visibleShortcut (): string {
		if ( this.shortcut !== '' )
			return this.shortcut
		else {
			return this.title.split( /\s/ ).reduce( ( response, word ) => response += word.slice( 0, 1 ), '' )
		}
	}

	get internationalName (): string | null {
		if ( this.shortcut === 'IJ' )
			return 'International Judge'

		if ( this.shortcut === 'IU' )
			return 'International Umpire'

		if ( this.shortcut === 'IRo' )
			return 'International Race Officer'

		return null
	}

	static piniaOptions = {
		persist: true,
	}
}
